// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

:host ::ng-deep .custom-spinner .p-progress-spinner-circle {
  z-index: 9999999999 !important;
  animation: custom-progress-spinner-dash 1.5s ease-in-out infinite, custom-progress-spinner-color 6s ease-in-out infinite;
}

@keyframes custom-progress-spinner-color {
  100%, 0% {
    stroke: #2d74ff;
  }
  40% {
    stroke: #2d74ff;
  }
  66% {
    stroke: #2d74ff;
  }
  80%, 90% {
    stroke: #2d74ff;
  }
}
@keyframes custom-progress-spinner-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
::ng-deep {
  /* Optional: show position indicator in red */
  /* Responsive */
}
::ng-deep ::-webkit-scrollbar {
  width: 8px;
  /* Remove scrollbar space */
  height: 10px;
  background: #e8f1f8;
  /* Optional: just make scrollbar invisible */
}
::ng-deep ::-webkit-scrollbar-thumb {
  background: #d1d6db;
  border-radius: 10px;
}
::ng-deep div.p-toast-top-right {
  top: 120px;
}
::ng-deep .p-toast {
  z-index: 1000000 !important;
}
::ng-deep .p-sidebar-mask.p-component-overlay {
  z-index: 9999 !important;
}
::ng-deep .tasks .card-header {
  top: 0;
  height: 48px;
  position: sticky;
  margin-bottom: 0;
  z-index: 2;
  background: white;
  width: 380px;
  align-items: flex-end;
}
::ng-deep .green {
  color: #03a17b;
}
::ng-deep .orange {
  color: #f58331;
}
::ng-deep .blue {
  color: #2f80ed;
}
::ng-deep .bdpBlue {
  background-color: #2f80ed;
}
::ng-deep .bdpOrange {
  background-color: #f58331;
}
::ng-deep .bdpGreen {
  background-color: #03a17b;
}
::ng-deep .timeline {
  max-height: 189px;
  height: 189px;
  list-style-type: none;
  display: flex;
  align-items: center;
  margin: 10px 60px;
}
::ng-deep .timeline .timeline-start-text {
  position: relative;
  top: 72px;
  right: 153px;
  font-weight: 600;
  font-size: 13px;
  color: #0080ff;
}
::ng-deep .timeline.bdp-align-start {
  justify-content: start;
}
::ng-deep .timeline-start-text {
  position: relative;
  top: 112px;
  font-weight: 600;
  font-size: 13px;
  color: #0080ff;
}
::ng-deep .li {
  transition: all 200ms ease-in;
}
::ng-deep .p-overlaypanel-content #badge {
  float: right;
  margin-left: 25px;
}
::ng-deep .p-overlaypanel-content .bdp-view-details {
  text-align: center;
  display: inline-block;
  width: 110px;
  border: none;
}
::ng-deep .p-overlaypanel-content .timestamp {
  width: 100%;
}
::ng-deep .p-overlaypanel-content .timestamp .timeline-text-align {
  margin-left: 75%;
}
::ng-deep .timestamp {
  margin-bottom: 16px;
  width: 130px;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  font-weight: 100;
  height: 74px;
}
::ng-deep .status {
  display: flex;
  justify-content: center;
  border-top: 2px solid #a8a8a8;
  position: relative;
  transition: all 200ms ease-in;
}
::ng-deep .status h4 {
  font-weight: 600;
}
::ng-deep .status:before {
  content: "";
  width: 8px;
  height: 8px;
  background-color: #a8a8a8;
  border-radius: 25px;
  border: 2px solid #a8a8a8;
  position: absolute;
  top: -8px;
  right: 0;
  transition: all 200ms ease-in;
}
::ng-deep .li.complete .status {
  border-top: 2px solid #0080ff;
}
::ng-deep .li.complete .status:before {
  background-color: #0080ff;
  border: none;
  width: 12px;
  height: 12px;
  transition: all 200ms ease-in;
}
::ng-deep .timeline-text-align {
  margin-right: -100px;
  padding-right: 0px;
  text-align: center;
  min-width: 180px;
  max-width: 125px;
}
::ng-deep .bdp-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .p-progressbar .p-progressbar-value .orange {
  background: #f58331;
}
::ng-deep .p-progressbar .p-progressbar-value .green {
  background: #03a17b;
}
::ng-deep .p-progressbar .p-progressbar-value .blue {
  background: #0080ff;
}
@media (min-device-width: 320px) and (max-device-width: 700px) {
  ::ng-deep .timeline {
    list-style-type: none;
    display: block;
  }
  ::ng-deep .li {
    transition: all 200ms ease-in;
    display: flex;
    width: inherit;
  }
  ::ng-deep .timestamp {
    width: 100px;
  }
  ::ng-deep .status:before {
    left: -8%;
    top: 30%;
    transition: all 200ms ease-in;
  }
}
::ng-deep .bdp-loading {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
::ng-deep div.p-multiselect-panel .p-multiselect-items .p-multiselect-item {
  padding: 0.2rem 1rem;
}
::ng-deep .bdp-note-mark {
  opacity: 0.1 !important;
}
::ng-deep .pi.pi-chevron-down {
  width: 20px;
  height: 20px;
  font-size: 10px;
  text-align: center;
  line-height: 20px;
}
::ng-deep .p-paginator .p-paginator-current {
  margin-left: auto;
}
::ng-deep .p-paginator .p-dropdown {
  max-width: 80px;
}
::ng-deep .p-progressbar {
  height: 4px;
  background-color: #d8dadc;
}
::ng-deep .p-calendar .p-datepicker {
  min-width: 25rem;
  left: -135px !important;
}
::ng-deep .p-calendar .p-datepicker td {
  font-weight: 400;
}
::ng-deep .p-datatable.p-datatable-customers .p-datatable-header {
  padding: 0px;
  text-align: left;
  font-size: 1.5rem;
  border: none;
  color: #1d2125;
}
::ng-deep .p-datatable.p-datatable-customers .p-paginator {
  padding: 1rem;
}
::ng-deep .p-datatable.p-datatable-customers .p-datatable-thead > tr > th {
  text-align: left;
  padding: 5px;
  color: #1d2125;
  height: 56px;
}
::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td {
  cursor: auto;
  padding: 10px 5px;
  overflow: hidden;
  white-space: pre-line;
}
::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td .p-inputtext {
  max-width: 100% !important;
}
::ng-deep .p-datatable.p-datatable-customers .p-dropdown-label:not(.p-placeholder) {
  text-transform: uppercase;
}
::ng-deep .p-datatable.p-datatable-customers .bdp-column-visibility .p-multiselect {
  max-width: 200px;
}
::ng-deep .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
::ng-deep .header-font-size {
  font-size: 28px;
  color: #1d2125;
  font-weight: 400 !important;
  line-height: 28px;
}
::ng-deep .label-font-size {
  font-size: 14px;
  color: #1d2125;
  line-height: 20px;
  font-weight: 500;
}
::ng-deep .percentage-font-size {
  font-size: 12px;
  color: #1d2125;
  font-weight: normal;
}
::ng-deep .lower-home-card-header-font {
  font-size: 16px;
  color: #1d2125 !important;
  line-height: 19.2px;
  font-weight: bold;
  width: 100%;
  border-bottom: 1px solid #d8dadc;
  padding-bottom: 5px;
}
::ng-deep .lower-home-card-height-scroll {
  height: 430px;
  max-height: 430px;
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .table-overlay-font-header {
  font-weight: 600;
  font-size: 16px;
  line-height: 19.2px;
  color: #1d2125;
}
::ng-deep .padding-lower-card {
  padding: 15px;
}
::ng-deep .bdp-on-time {
  color: #2d74ff;
}
::ng-deep .bdp-late-by {
  color: #f58331;
}
::ng-deep .bdp-early-riser {
  color: #03a17b;
}
::ng-deep .bdp-inactive {
  color: #697a76;
}
::ng-deep .bdp-openStatus,
::ng-deep .bdp-resolvedStatus,
::ng-deep .bdp-ignoredStatus {
  color: white;
  padding: 6px 8px;
  text-align: center;
  border-radius: 2px;
}
::ng-deep .bdp-openStatus {
  background-color: #2d74ff;
}
::ng-deep .bdp-ignoredStatus {
  background-color: #f58331;
}
::ng-deep .bdp-resolvedStatus {
  background-color: #03a17b;
}
::ng-deep .highlightedErrorType {
  background-color: #fff1f1;
  color: red;
  font-weight: 600;
}
::ng-deep .bdp-ship-icon {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 3px;
  left: 3px;
}
::ng-deep .bdp-ship-icon.bdp-ship-delay {
  background-image: url('bdp-late-shipment.05e6ff37884105e3.svg');
}
::ng-deep .bdp-ship-icon.bdp-ship-on-time {
  background-image: url('bdp-ontime-shipment.3f5892f38550db89.svg');
}
::ng-deep .bdp-ship-icon.bdp-ship-early-arrive {
  background-image: url('bdp-early-shipment.9ffc6f28aa16843c.svg');
}
::ng-deep .bdp-ship-icon.bdp-ship-completed {
  background-image: url('bdp-vessel_completed.166c3580ec78ee9c.svg');
}
::ng-deep .bdp-flight-icon {
  width: 31px;
  height: 31px;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 3px;
}
::ng-deep .bdp-flight-icon.bdp-flight-delay {
  background-image: url('bdp-air-late-shipment.d421e6d862d8b82b.svg');
}
::ng-deep .bdp-flight-icon.bdp-flight-on-time {
  background-image: url('bdp-air-ontime-shipment.fa183a08f31438a3.svg');
}
::ng-deep .bdp-flight-icon.bdp-flight-early-arrive {
  background-image: url('bdp-air-early-shipment.eae0c1e8f32c0824.svg');
}
::ng-deep .bdp-flight-icon.bdp-flight-completed {
  background-image: url('bdp-vessel_completed.166c3580ec78ee9c.svg');
}
::ng-deep .mapboxgl-ctrl-logo {
  display: none !important;
}
::ng-deep div.p-tooltip .p-tooltip-text {
  background: #fff;
  color: #444;
  width: max-content;
  max-width: 180px;
  word-wrap: break-word;
}
::ng-deep .bdp-view-details {
  border-top: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding-top: 2px;
  width: 460px;
}
::ng-deep .bdp-view-details a {
  color: #2d74ff;
}
::ng-deep ::ng-deep .p-dialog .p-dialog-footer {
  text-align: right;
}
::ng-deep .bdp-toaster .p-toast {
  width: 50rem;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message .p-toast-message-content {
  padding: 20px 24px;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-custom {
  background-color: #e1cfe7;
  border: none;
  border-width: 0 0 0 6px;
  color: #1d2125;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-error, ::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success {
  width: -moz-fit-content;
  width: fit-content;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success {
  background-color: #d7faef;
  border: none;
  border-width: 0 0 0 6px;
  color: #1d2125;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success i.fal.fa-check-circle.bpd-success {
  color: #03a17b;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p {
  text-align: left;
  margin-bottom: 0px;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p .bdp-message-seperator {
  height: 29px;
  border-right: 2px solid #828282;
  position: absolute;
  right: 164px;
  width: 0px;
  top: 26px;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p .bdp-undo {
  margin-left: 10px;
  padding: 0px 20px 0px 0px;
  float: right;
  color: #2d74ff;
  text-decoration: underline;
  cursor: pointer;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p .bdp-undo:hover {
  color: #004ce1;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p .bdp-undo:visited {
  color: #004ce1;
}
::ng-deep .bdp-toaster .p-toast .p-toast-message.p-toast-message-success p .bdp-undo i {
  margin: 0px 20px;
  font-weight: bold;
  color: #828282;
  font-size: 1rem;
}
::ng-deep .bdp-toaster .p-toast .bdp-toaster-text {
  padding-right: 25px;
  display: flex;
  align-items: center;
}
::ng-deep .bdp-toaster .p-toast .p-toast-icon-close {
  color: #2c1e30;
  position: absolute;
  right: 20px;
  top: 16px;
}
::ng-deep div.p-tooltip.p-component {
  z-index: 999999 !important;
}
::ng-deep div.p-tooltip.p-component .p-tooltip-arrow {
  border-right-color: #fff;
  border-left-color: #fff;
}
::ng-deep .bdp-camelcase {
  text-transform: capitalize;
}
::ng-deep .bdp-link {
  color: #004ce1;
  cursor: pointer;
}
::ng-deep .p-button.p-datepicker-trigger {
  background: #fff;
  color: var(--bdpFontPrimary);
  border-color: #d7d8d9;
}
::ng-deep .bdp-edit-info {
  position: absolute;
  bottom: -55px;
  left: 0px;
  width: 200px;
  height: 50px;
  color: #fff;
  padding: 10px 4px;
  border-radius: 6px;
  z-index: 9;
  background-color: rgba(68, 68, 68, 0.9);
  white-space: initial;
}
::ng-deep .bdp-edit-info::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid rgba(68, 68, 68, 0.9);
  top: -5px;
  left: 10px;
  position: absolute;
}
::ng-deep .bdp-refresh-button {
  background-color: var(--bdpButtonSecondary);
  color: var(--bdpFontLight);
  border: 1px solid #d7d8d9;
}
::ng-deep .logo-icon {
  width: 75%;
}
::ng-deep .bdp-robot-logo-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::ng-deep .bdp-robot-logo-wrapper .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
}
::ng-deep #notAssociated {
  width: 100%;
  height: 75vh;
  display: flex;
  align-items: center;
}

:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: none !important;
  border: 1px solid !important;
  border-color: #2d74ff !important;
  color: #1d2125;
}

::ng-deep .p-input-icon-left > .p-inputtext {
  height: 36px !important;
}
::ng-deep .p-overlay {
  z-index: 99999 !important;
}
::ng-deep .p-multiselect-label {
  height: 35px;
}
::ng-deep .timeline-font-header {
  font-size: 12px !important;
  line-height: 14.4px;
  font-weight: 600 !important;
  margin-bottom: 2px !important;
}
::ng-deep .timeline-font-body {
  font-size: 12px !important;
  line-height: 14.4px;
  font-weight: 500 !important;
  margin-bottom: 2px !important;
}
::ng-deep .timeline-icon-font-size {
  font-size: 12px;
}
::ng-deep .p-multiselect-filter-container .p-inputtext {
  width: 100% !important;
}
::ng-deep .home-cards-intro-text {
  font-size: 12px;
}
::ng-deep ngx-avatars .avatar-container .avatar-content {
  color: black;
}
::ng-deep .breadcrum-button-color {
  color: #2d74ff !important;
}
::ng-deep .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,
::ng-deep .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,
::ng-deep .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,
::ng-deep .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
  position: absolute;
  right: 4px;
  top: 4px;
  color: #828282;
}
::ng-deep .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close .pi,
::ng-deep .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close .pi,
::ng-deep .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close .pi,
::ng-deep .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close .pi {
  font-weight: bold;
}
::ng-deep .p-toast .p-toast-message.p-toast-message-success {
  background: #d7faef;
  border: none;
  color: #1d2125;
}
::ng-deep .p-toast .p-toast-message.p-toast-message-warn {
  background: #ffecb3;
  border: none;
  color: #1d2125;
}
::ng-deep .p-toast .p-toast-message.p-toast-message-error {
  background: #ffd9d9;
  border: none;
  color: #1d2125;
}
::ng-deep .p-toast .p-toast-message .p-toast-message-content {
  padding-right: 2rem;
}
::ng-deep #resetPasswordToaster .p-toast .p-toast-message.p-toast-message-error {
  width: max-content;
}
::ng-deep #resetPasswordToaster div.p-toast-top-right {
  right: 100px;
}
::ng-deep #resetPasswordToaster i.fal.fa-times-circle.bpd-error {
  color: #ec4e4e;
}
::ng-deep #resetPasswordToaster .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,
::ng-deep #resetPasswordToaster .p-toast-icon-close {
  top: 4px;
}
::ng-deep #registerToaster .p-toast .p-toast-message.p-toast-message-success {
  width: max-content;
}
::ng-deep #registerToaster div.p-toast-top-right {
  right: 172px;
}
::ng-deep #registerToaster i.fal.fa-check-circle.bpd-success {
  color: #03a17b;
}
::ng-deep #registerToaster .p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,
::ng-deep #registerToaster .p-toast-icon-close {
  top: 4px;
}
::ng-deep #no-shipment-toaster .p-toast .p-toast-message.p-toast-message-error {
  width: 530px;
  position: relative;
  right: 185px;
}
::ng-deep #columnSettingsDropdown .p-multiselect-panel .p-multiselect-header .p-checkbox {
  display: none;
}
::ng-deep .exception-body .exception-bottom .exception-wrapper button {
  margin: 0 auto 52px auto;
}
::ng-deep .exception-body .exception-bottom .exception-wrapper .logo-icon {
  height: 30%;
  width: 100%;
  display: block;
  margin: 0;
}
::ng-deep .bdp-success {
  color: #03a17b;
}
::ng-deep .bdp-error {
  color: #ec4e4e;
}

::ng-deep .md-drppicker.inline {
  width: max-content !important;
  box-shadow: none !important;
}
::ng-deep .md-drppicker .btn {
  background-color: #2d74ff !important;
  border-radius: 5px !important;
  margin-top: 12px;
  font-family: "Montserrat" !important;
}
::ng-deep .md-drppicker .btn.btn-default {
  background: white !important;
  box-shadow: none;
  float: right;
  margin-right: 8px;
}
::ng-deep .md-drppicker td.active {
  background-color: #2d74ff !important;
}

::ng-deep .overview-box-1 .overview-content .overview-graph > span:hover .graph-tooltip {
  left: -65px;
}

::ng-deep .bdp-extracompanies-panel .p-overlaypanel-content {
  max-height: 256px !important;
  overflow-y: auto !important;
}

::ng-deep .bdp-table {
  background-color: #fff;
}
::ng-deep .bdp-table-icon-header {
  min-width: 100px !important;
  text-align: center !important;
}
::ng-deep .bdp-table-column-width {
  min-width: 300px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAEA;EACI,8BAAA;EACA,wHAAA;AACJ;;AAIA;EAEI;IAEI,eAAA;EAHN;EAME;IACI,eAAA;EAJN;EAOE;IACI,eAAA;EALN;EAQE;IAEI,eAAA;EAPN;AACF;AAUA;EACI;IACI,wBAAA;IACA,oBAAA;EARN;EAWE;IACI,yBAAA;IACA,wBAAA;EATN;EAYE;IACI,yBAAA;IACA,yBAAA;EAVN;AACF;AAaA;EASI,6CAAA;EAqUA,eAAA;AAvVJ;AAUI;EACI,UAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AARR;AAYI;EACI,mBAAA;EACA,mBAAA;AAVR;AAaI;EACI,UAAA;AAXR;AAcI;EACI,2BAAA;AAZR;AAeI;EACI,wBAAA;AAbR;AAiBI;EACI,MAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AAfR;AAkBI;EACI,cAAA;AAhBR;AAmBI;EACI,cAAA;AAjBR;AAoBI;EACI,cAAA;AAlBR;AAqBI;EACI,yBAAA;AAnBR;AAsBI;EACI,yBAAA;AApBR;AAuBI;EACI,yBAAA;AArBR;AAyBI;EACI,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EAEA,iBAAA;AAxBR;AAsCQ;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AApCZ;AAuCQ;EACI,sBAAA;AArCZ;AAyCI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvCR;AA0CI;EACI,6BAAA;AAxCR;AA4CQ;EACI,YAAA;EACA,iBAAA;AA1CZ;AA6CQ;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AA3CZ;AA8CQ;EACI,WAAA;AA5CZ;AA8CY;EACI,gBAAA;AA5ChB;AAmDI;EACI,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAjDR;AAoDI;EAEI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;AAnDR;AAsDI;EACI,gBAAA;AApDR;AAuDI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;AArDR;AAwDI;EACI,6BAAA;AAtDR;AAyDI;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AAvDR;AA0DI;EACI,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxDR;AA2DI;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzDR;AA6DQ;EACI,mBAAA;AA3DZ;AA8DQ;EACI,mBAAA;AA5DZ;AA+DQ;EACI,mBAAA;AA7DZ;AAiEI;EACI;IACI,qBAAA;IACA,cAAA;EA/DV;EAkEM;IACI,6BAAA;IACA,aAAA;IACA,cAAA;EAhEV;EAmEM;IACI,YAAA;EAjEV;EAoEM;IACI,SAAA;IACA,QAAA;IACA,6BAAA;EAlEV;AACF;AAuEI;EAEI,2BAAA;EACA,sBAAA;EACA,4BAAA;AAtER;AA2EY;EACI,oBAAA;AAzEhB;AA8EI;EACI,uBAAA;AA5ER;AA+EI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA7ER;AAiFQ;EACI,iBAAA;AA/EZ;AAkFQ;EACI,eAAA;AAhFZ;AAoFI;EACI,WAAA;EACA,yBAAA;AAlFR;AAyFI;EACI,gBAAA;EACA,uBAAA;AAvFR;AAwFQ;EACI,gBAAA;AAtFZ;AA2FQ;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAzFZ;AA4FQ;EACI,aAAA;AA1FZ;AA6FQ;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AA3FZ;AA8FQ;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AA5FZ;AA8FY;EACI,0BAAA;AA5FhB;AAgGQ;EACI,yBAAA;AA9FZ;AAkGY;EACI,gBAAA;AAhGhB;AAsGI;EACI,aAAA;AApGR;AAuGI;EACI,eAAA;EACA,cAAA;EACA,2BAAA;EACA,iBAAA;AArGR;AAwGI;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAtGR;AAyGI;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AAvGR;AA0GI;EACI,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;AAxGR;AA2GI;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAzGR;AA4GI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA1GR;AA6GI;EACI,aAAA;AA3GR;AA8GI;EACI,cAAA;AA5GR;AA+GI;EACI,cAAA;AA7GR;AAgHI;EACI,cAAA;AA9GR;AAiHI;EACI,cAAA;AA/GR;AAkHI;;;EAGI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAhHR;AAmHI;EACI,yBAAA;AAjHR;AAoHI;EACI,yBAAA;AAlHR;AAqHI;EACI,yBAAA;AAnHR;AAsHI;EACI,yBAAA;EACA,UAAA;EACA,gBAAA;AApHR;AAuHI;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AArHR;AAuHQ;EACI,+DAAA;AArHZ;AAwHQ;EACI,iEAAA;AAtHZ;AAyHQ;EACI,gEAAA;AAvHZ;AA0HQ;EACI,kEAAA;AAxHZ;AA4HI;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EAEA,SAAA;AA3HR;AA6HQ;EACI,mEAAA;AA3HZ;AA8HQ;EACI,qEAAA;AA5HZ;AA+HQ;EACI,oEAAA;AA7HZ;AAgIQ;EACI,kEAAA;AA9HZ;AAkII;EACI,wBAAA;AAhIR;AAoIQ;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EAEA,qBAAA;AAnIZ;AAuII;EACI,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AArIR;AAuIQ;EACI,cAAA;AArIZ;AA0IQ;EACI,iBAAA;AAxIZ;AA6IQ;EACI,YAAA;AA3IZ;AA+IgB;EACI,kBAAA;AA7IpB;AAgJgB;EACI,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AA9IpB;AAiJgB;EAEI,uBAAA;EAAA,kBAAA;AAhJpB;AAmJgB;EACI,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AAjJpB;AAmJoB;EACI,cAAA;AAjJxB;AAoJoB;EACI,gBAAA;EACA,kBAAA;AAlJxB;AAoJwB;EACI,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAlJ5B;AAqJwB;EACI,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AAnJ5B;AAqJ4B;EACI,cAAA;AAnJhC;AAsJ4B;EACI,cAAA;AApJhC;AAuJ4B;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AArJhC;AA4JY;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AA1JhB;AA6JY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3JhB;AAgKI;EACI,0BAAA;AA9JR;AAgKQ;EACI,wBAAA;EACA,uBAAA;AA9JZ;AAkKI;EACI,0BAAA;AAhKR;AAmKI;EACI,cAAA;EACA,eAAA;AAjKR;AAoKI;EACI,gBAAA;EACA,4BAAA;EACA,qBAAA;AAlKR;AAqKI;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,uCAAA;EACA,oBAAA;AAnKR;AAqKQ;EACI,WAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAnKZ;AAuKI;EACI,2CAAA;EACA,0BAAA;EACA,yBAAA;AArKR;AAwKI;EACI,UAAA;AAtKR;AAyKI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAvKR;AAyKQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAvKZ;AA2KI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAzKR;;AA6KA;EACI,2BAAA;EACA,4BAAA;EACA,gCAAA;EACA,cAAA;AA1KJ;;AA8KI;EACI,uBAAA;AA3KR;AA8KI;EACI,yBAAA;AA5KR;AA+KI;EACI,YAAA;AA7KR;AAgLI;EACI,0BAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;AA9KR;AAiLI;EACI,0BAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;AA/KR;AAoLI;EACI,eAAA;AAlLR;AAqLI;EACI,sBAAA;AAnLR;AAsLI;EACI,eAAA;AApLR;AAuLI;EACI,YAAA;AArLR;AAwLI;EACI,yBAAA;AAtLR;AAyLI;;;;EAII,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;AAvLR;AAyLQ;;;;EACI,iBAAA;AApLZ;AAwLI;EACI,mBAAA;EACA,YAAA;EACA,cAAA;AAtLR;AAyLI;EACI,mBAAA;EACA,YAAA;EACA,cAAA;AAvLR;AA0LI;EACI,mBAAA;EACA,YAAA;EACA,cAAA;AAxLR;AA2LI;EACI,mBAAA;AAzLR;AA6LQ;EACI,kBAAA;AA3LZ;AA8LQ;EACI,YAAA;AA5LZ;AA+LQ;EACI,cAAA;AA7LZ;AAgMQ;;EAEI,QAAA;AA9LZ;AAmMQ;EACI,kBAAA;AAjMZ;AAoMQ;EACI,YAAA;AAlMZ;AAqMQ;EACI,cAAA;AAnMZ;AAsMQ;;EAEI,QAAA;AApMZ;AAyMQ;EACI,YAAA;EACA,kBAAA;EACA,YAAA;AAvMZ;AA4MQ;EACI,aAAA;AA1MZ;AA8MI;EACI,wBAAA;AA5MR;AA+MI;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;AA7MR;AAgNI;EACI,cAAA;AA9MR;AAiNI;EACI,cAAA;AA/MR;;AAoNI;EACI,6BAAA;EACA,2BAAA;AAjNR;AAoNI;EACI,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,oCAAA;AAlNR;AAqNI;EACI,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAnNR;AAuNI;EACI,oCAAA;AArNR;;AA2NI;EACI,WAAA;AAxNR;;AA+NI;EACI,4BAAA;EACA,2BAAA;AA5NR;;AAkOI;EACI,sBAAA;AA/NR;AAkOI;EACI,2BAAA;EACA,6BAAA;AAhOR;AAmOI;EACI,2BAAA;AAjOR","sourcesContent":["html {\n    scroll-behavior: smooth;\n}\n\n:host ::ng-deep .custom-spinner .p-progress-spinner-circle {\n    z-index: 9999999999 !important;\n    animation: custom-progress-spinner-dash 1.5s ease-in-out infinite,\n        custom-progress-spinner-color 6s ease-in-out infinite;\n}\n\n\n@keyframes custom-progress-spinner-color {\n\n    100%,\n    0% {\n        stroke: #2d74ff;\n    }\n\n    40% {\n        stroke: #2d74ff;\n    }\n\n    66% {\n        stroke: #2d74ff;\n    }\n\n    80%,\n    90% {\n        stroke: #2d74ff;\n    }\n}\n\n@keyframes custom-progress-spinner-dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n::ng-deep {\n    ::-webkit-scrollbar {\n        width: 8px;\n        /* Remove scrollbar space */\n        height: 10px;\n        background: #e8f1f8;\n        /* Optional: just make scrollbar invisible */\n    }\n\n    /* Optional: show position indicator in red */\n    ::-webkit-scrollbar-thumb {\n        background: #d1d6db;\n        border-radius: 10px;\n    }\n\n    div.p-toast-top-right {\n        top: 120px;\n    }\n\n    .p-toast {\n        z-index: 1000000 !important;\n    }\n\n    .p-sidebar-mask.p-component-overlay {\n        z-index: 9999 !important;\n    }\n\n\n    .tasks .card-header {\n        top: 0;\n        height: 48px;\n        position: sticky;\n        margin-bottom: 0;\n        z-index: 2;\n        background: white;\n        width: 380px;\n        align-items: flex-end;\n    }\n\n    .green {\n        color: #03a17b;\n    }\n\n    .orange {\n        color: #f58331;\n    }\n\n    .blue {\n        color: #2f80ed;\n    }\n\n    .bdpBlue {\n        background-color: #2f80ed;\n    }\n\n    .bdpOrange {\n        background-color: #f58331;\n    }\n\n    .bdpGreen {\n        background-color: #03a17b;\n    }\n\n    //Horizontal Timeline\n    .timeline {\n        max-height: 189px;\n        height: 189px;\n        list-style-type: none;\n        display: flex;\n        align-items: center;\n        // justify-content: center;\n        margin: 10px 60px;\n        // margin-left: 88px;\n\n        .complete+.incomplete {\n            ~.complete {\n                // background: red;\n            }\n\n            // border: 1px solid #0080ff;\n            // border-radius: 50%;\n            // padding: 2px;\n            // margin-right: -25px;\n        }\n\n        .timeline-start-text {\n            position: relative;\n            top: 72px;\n            right: 153px;\n            font-weight: 600;\n            font-size: 13px;\n            color: #0080ff;\n        }\n\n        &.bdp-align-start {\n            justify-content: start;\n        }\n    }\n\n    .timeline-start-text {\n        position: relative;\n        top: 112px;\n        font-weight: 600;\n        font-size: 13px;\n        color: #0080ff;\n    }\n\n    .li {\n        transition: all 200ms ease-in;\n    }\n\n    .p-overlaypanel-content {\n        #badge {\n            float: right;\n            margin-left: 25px;\n        }\n\n        .bdp-view-details {\n            text-align: center;\n            display: inline-block;\n            width: 110px;\n            border: none;\n        }\n\n        .timestamp {\n            width: 100%;\n\n            .timeline-text-align {\n                margin-left: 75%;\n                // margin-right: -69px;\n                // min-width: 120px;\n            }\n        }\n    }\n\n    .timestamp {\n        margin-bottom: 16px;\n        width: 130px;\n        padding: 0px 16px;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: center;\n        font-weight: 100;\n        height: 74px;\n    }\n\n    .status {\n        // padding: 0px 35px;\n        display: flex;\n        justify-content: center;\n        border-top: 2px solid #a8a8a8;\n        position: relative;\n        transition: all 200ms ease-in;\n    }\n\n    .status h4 {\n        font-weight: 600;\n    }\n\n    .status:before {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        background-color: #a8a8a8;\n        border-radius: 25px;\n        border: 2px solid #a8a8a8;\n        position: absolute;\n        top: -8px;\n        right: 0;\n        transition: all 200ms ease-in;\n    }\n\n    .li.complete .status {\n        border-top: 2px solid #0080ff;\n    }\n\n    .li.complete .status:before {\n        background-color: #0080ff;\n        border: none;\n        width: 12px;\n        height: 12px;\n        transition: all 200ms ease-in;\n    }\n\n    .timeline-text-align {\n        margin-right: -100px;\n        padding-right: 0px;\n        text-align: center;\n        min-width: 180px;\n        max-width: 125px;\n    }\n\n    .bdp-text-overflow {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .p-progressbar .p-progressbar-value {\n        .orange {\n            background: #f58331;\n        }\n\n        .green {\n            background: #03a17b;\n        }\n\n        .blue {\n            background: #0080ff;\n        }\n    }\n\n    @media (min-device-width: 320px) and (max-device-width: 700px) {\n        .timeline {\n            list-style-type: none;\n            display: block;\n        }\n\n        .li {\n            transition: all 200ms ease-in;\n            display: flex;\n            width: inherit;\n        }\n\n        .timestamp {\n            width: 100px;\n        }\n\n        .status:before {\n            left: -8%;\n            top: 30%;\n            transition: all 200ms ease-in;\n        }\n    }\n\n    // Horizontal Timeline ends here\n\n    .bdp-loading {\n        // background-image: url('../assets/layout/images/loading.gif');\n        background-position: center;\n        background-size: cover;\n        background-repeat: no-repeat;\n    }\n\n    div.p-multiselect-panel {\n        .p-multiselect-items {\n            .p-multiselect-item {\n                padding: 0.2rem 1rem;\n            }\n        }\n    }\n\n    .bdp-note-mark {\n        opacity: 0.1 !important;\n    }\n\n    .pi.pi-chevron-down {\n        width: 20px;\n        height: 20px;\n        font-size: 10px;\n        text-align: center;\n        line-height: 20px;\n    }\n\n    .p-paginator {\n        .p-paginator-current {\n            margin-left: auto;\n        }\n\n        .p-dropdown {\n            max-width: 80px;\n        }\n    }\n\n    .p-progressbar {\n        height: 4px;\n        background-color: #d8dadc;\n\n        .p-progressbar-value {\n        //    background-color: #607d8b;\n        }\n    }\n\n    .p-calendar .p-datepicker {\n        min-width: 25rem;\n        left: -135px !important;\n        td {\n            font-weight: 400;\n        }\n    }\n\n    .p-datatable.p-datatable-customers {\n        .p-datatable-header {\n            padding: 0px;\n            text-align: left;\n            font-size: 1.5rem;\n            border: none;\n            color: #1d2125;\n        }\n\n        .p-paginator {\n            padding: 1rem;\n        }\n\n        .p-datatable-thead>tr>th {\n            text-align: left;\n            padding: 5px;\n            color: #1d2125;\n            height: 56px;\n        }\n\n        .p-datatable-tbody>tr>td {\n            cursor: auto;\n            padding: 10px 5px;\n            overflow: hidden;\n            white-space: pre-line;\n\n            .p-inputtext {\n                max-width: 100% !important;\n            }\n        }\n\n        .p-dropdown-label:not(.p-placeholder) {\n            text-transform: uppercase;\n        }\n\n        .bdp-column-visibility {\n            .p-multiselect {\n                max-width: 200px;\n            }\n        }\n    }\n\n    /* Responsive */\n    .p-datatable-customers .p-datatable-tbody>tr>td .p-column-title {\n        display: none;\n    }\n\n    .header-font-size {\n        font-size: 28px;\n        color: #1d2125;\n        font-weight: 400 !important;\n        line-height: 28px;\n    }\n\n    .label-font-size {\n        font-size: 14px;\n        color: #1d2125;\n        line-height: 20px;\n        font-weight: 500;\n    }\n\n    .percentage-font-size {\n        font-size: 12px;\n        color: #1d2125;\n        font-weight: normal;\n    }\n\n    .lower-home-card-header-font {\n        font-size: 16px;\n        color: #1d2125 !important;\n        line-height: 19.2px;\n        font-weight: bold;\n        width: 100%;\n        border-bottom: 1px solid #d8dadc;\n        padding-bottom: 5px;\n    }\n\n    .lower-home-card-height-scroll {\n        height: 430px;\n        max-height: 430px;\n        overflow-x: hidden;\n        overflow-y: auto;\n    }\n\n    .table-overlay-font-header {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 19.2px;\n        color: #1d2125;\n    }\n\n    .padding-lower-card {\n        padding: 15px;\n    }\n\n    .bdp-on-time {\n        color: #2d74ff;\n    }\n\n    .bdp-late-by {\n        color: #f58331;\n    }\n\n    .bdp-early-riser {\n        color: #03a17b;\n    }\n\n    .bdp-inactive {\n        color: #697a76;\n    }\n\n    .bdp-openStatus,\n    .bdp-resolvedStatus,\n    .bdp-ignoredStatus {\n        color: white;\n        padding: 6px 8px;\n        text-align: center;\n        border-radius: 2px;\n    }\n\n    .bdp-openStatus {\n        background-color: #2d74ff;\n    }\n\n    .bdp-ignoredStatus {\n        background-color: #f58331;\n    }\n\n    .bdp-resolvedStatus {\n        background-color: #03a17b;\n    }\n\n    .highlightedErrorType {\n        background-color: #fff1f1;\n        color: red;\n        font-weight: 600;\n    }\n\n    .bdp-ship-icon {\n        width: 30px;\n        height: 30px;\n        background-repeat: no-repeat;\n        background-position: center;\n        position: absolute;\n        top: 3px;\n        left: 3px;\n\n        &.bdp-ship-delay {\n            background-image: url(\"../assets/layout/images/bdp-late-shipment.svg\");\n        }\n\n        &.bdp-ship-on-time {\n            background-image: url(\"../assets/layout/images/bdp-ontime-shipment.svg\");\n        }\n\n        &.bdp-ship-early-arrive {\n            background-image: url(\"../assets/layout/images/bdp-early-shipment.svg\");\n        }\n\n        &.bdp-ship-completed {\n            background-image: url(\"../assets/layout/images/bdp-vessel_completed.svg\");\n        }\n    }\n\n    .bdp-flight-icon {\n        width: 31px;\n        height: 31px;\n        background-repeat: no-repeat;\n        background-position: center;\n        position: absolute;\n     //   top: 3px;\n        left: 3px;\n\n        &.bdp-flight-delay {\n            background-image: url(\"../assets/layout/images/bdp-air-late-shipment.svg\");\n        }\n\n        &.bdp-flight-on-time {\n            background-image: url(\"../assets/layout/images/bdp-air-ontime-shipment.svg\");\n        }\n\n        &.bdp-flight-early-arrive {\n            background-image: url(\"../assets/layout/images/bdp-air-early-shipment.svg\");\n        }\n\n        &.bdp-flight-completed {\n            background-image: url(\"../assets/layout/images/bdp-vessel_completed.svg\");\n        }\n    }\n\n    .mapboxgl-ctrl-logo {\n        display: none !important;\n    }\n\n    div.p-tooltip {\n        .p-tooltip-text {\n            background: #fff;\n            color: #444;\n            width: max-content;\n            max-width: 180px;\n            // word-break: break-all;\n            word-wrap: break-word;\n        }\n    }\n\n    .bdp-view-details {\n        border-top: 2px solid #ddd;\n        text-align: center;\n        display: inline-block;\n        padding-top: 2px;\n        width: 460px;\n\n        a {\n            color: #2d74ff;\n        }\n    }\n\n    ::ng-deep {\n        .p-dialog .p-dialog-footer {\n            text-align: right;\n        }\n    }\n\n    .bdp-toaster {\n        .p-toast {\n            width: 50rem;\n            // margin-left: -25em;\n\n            .p-toast-message {\n                .p-toast-message-content {\n                    padding: 20px 24px;\n                }\n\n                &.p-toast-message-custom {\n                    background-color: #e1cfe7;\n                    border: none;\n                    border-width: 0 0 0 6px;\n                    color: #1d2125;\n                }\n\n                &.p-toast-message-error,\n                &.p-toast-message-success {\n                    width: fit-content;\n                }\n\n                &.p-toast-message-success {\n                    background-color: #d7faef;\n                    border: none;\n                    border-width: 0 0 0 6px;\n                    color: #1d2125;\n\n                    i.fal.fa-check-circle.bpd-success {\n                        color: #03a17b;\n                    }\n\n                    p {\n                        text-align: left;\n                        margin-bottom: 0px;\n\n                        .bdp-message-seperator {\n                            height: 29px;\n                            border-right: 2px solid #828282;\n                            position: absolute;\n                            right: 164px;\n                            width: 0px;\n                            top: 26px;\n                        }\n\n                        .bdp-undo {\n                            margin-left: 10px;\n                            padding: 0px 20px 0px 0px;\n                            float: right;\n                            color: #2d74ff;\n                            text-decoration: underline;\n                            cursor: pointer;\n\n                            &:hover {\n                                color: #004ce1;\n                            }\n\n                            &:visited {\n                                color: #004ce1;\n                            }\n\n                            i {\n                                margin: 0px 20px;\n                                font-weight: bold;\n                                color: #828282;\n                                font-size: 1rem;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .bdp-toaster-text {\n                padding-right: 25px;\n                display: flex;\n                align-items: center;\n            }\n\n            .p-toast-icon-close {\n                color: #2c1e30;\n                position: absolute;\n                right: 20px;\n                top: 16px;\n            }\n        }\n    }\n\n    div.p-tooltip.p-component {\n        z-index: 999999 !important;\n\n        .p-tooltip-arrow {\n            border-right-color: #fff;\n            border-left-color: #fff;\n        }\n    }\n\n    .bdp-camelcase {\n        text-transform: capitalize;\n    }\n\n    .bdp-link {\n        color: #004ce1;\n        cursor: pointer;\n    }\n\n    .p-button.p-datepicker-trigger {\n        background: #fff;\n        color: var(--bdpFontPrimary);\n        border-color: #d7d8d9;\n    }\n\n    .bdp-edit-info {\n        position: absolute;\n        bottom: -55px;\n        left: 0px;\n        width: 200px;\n        height: 50px;\n        color: #fff;\n        padding: 10px 4px;\n        border-radius: 6px;\n        z-index: 9;\n        background-color: rgba(68, 68, 68, 0.9);\n        white-space: initial;\n\n        &::before {\n            content: \"\";\n            width: 0;\n            height: 0;\n            border-left: 5px solid transparent;\n            border-right: 5px solid transparent;\n            border-bottom: 5px solid rgb(68 68 68 / 90%);\n            top: -5px;\n            left: 10px;\n            position: absolute;\n        }\n    }\n\n    .bdp-refresh-button {\n        background-color: var(--bdpButtonSecondary);\n        color: var(--bdpFontLight);\n        border: 1px solid #d7d8d9;\n    }\n\n    .logo-icon {\n        width: 75%;\n    }\n\n    .bdp-robot-logo-wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .logo {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 70%;\n        }\n    }\n\n    #notAssociated {\n        width: 100%;\n        height: 75vh;\n        display: flex;\n        align-items: center;\n    }\n}\n\n:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {\n    background: none !important;\n    border: 1px solid !important;\n    border-color: #2d74ff !important;\n    color: #1d2125;\n}\n\n::ng-deep {\n    .p-input-icon-left>.p-inputtext {\n        height: 36px !important;\n    }\n\n    .p-overlay {\n        z-index: 99999 !important;\n    }\n\n    .p-multiselect-label {\n        height: 35px;\n    }\n\n    .timeline-font-header {\n        font-size: 12px !important;\n        line-height: 14.4px;\n        font-weight: 600 !important;\n        margin-bottom: 2px !important;\n    }\n\n    .timeline-font-body {\n        font-size: 12px !important;\n        line-height: 14.4px;\n        font-weight: 500 !important;\n        margin-bottom: 2px !important;\n    }\n\n\n\n    .timeline-icon-font-size {\n        font-size: 12px;\n    }\n\n    .p-multiselect-filter-container .p-inputtext {\n        width: 100% !important;\n    }\n\n    .home-cards-intro-text {\n        font-size: 12px;\n    }\n\n    ngx-avatars .avatar-container .avatar-content {\n        color: black;\n    }\n\n    .breadcrum-button-color {\n        color: #2d74ff !important;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {\n        position: absolute;\n        right: 4px;\n        top: 4px;\n        color: #828282;\n\n        .pi {\n            font-weight: bold;\n        }\n    }\n\n    .p-toast .p-toast-message.p-toast-message-success {\n        background: #d7faef;\n        border: none;\n        color: #1d2125;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-warn {\n        background: #ffecb3;\n        border: none;\n        color: #1d2125;\n    }\n\n    .p-toast .p-toast-message.p-toast-message-error {\n        background: #ffd9d9;\n        border: none;\n        color: #1d2125;\n    }\n\n    .p-toast .p-toast-message .p-toast-message-content {\n        padding-right: 2rem;\n    }\n\n    #resetPasswordToaster {\n        .p-toast .p-toast-message.p-toast-message-error {\n            width: max-content;\n        }\n\n        div.p-toast-top-right {\n            right: 100px;\n        }\n\n        i.fal.fa-times-circle.bpd-error {\n            color: #ec4e4e;\n        }\n\n        .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon,\n        .p-toast-icon-close {\n            top: 4px;\n        }\n    }\n\n    #registerToaster {\n        .p-toast .p-toast-message.p-toast-message-success {\n            width: max-content;\n        }\n\n        div.p-toast-top-right {\n            right: 172px;\n        }\n\n        i.fal.fa-check-circle.bpd-success {\n            color: #03a17b;\n        }\n\n        .p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon,\n        .p-toast-icon-close {\n            top: 4px;\n        }\n    }\n\n    #no-shipment-toaster {\n        .p-toast .p-toast-message.p-toast-message-error {\n            width: 530px;\n            position: relative;\n            right: 185px;\n        }\n    }\n\n    #columnSettingsDropdown {\n        .p-multiselect-panel .p-multiselect-header .p-checkbox {\n            display: none;\n        }\n    }\n\n    .exception-body .exception-bottom .exception-wrapper button {\n        margin: 0 auto 52px auto;\n    }\n\n    .exception-body .exception-bottom .exception-wrapper .logo-icon {\n        height: 30%;\n        width: 100%;\n        display: block;\n        margin: 0;\n    }\n\n    .bdp-success {\n        color: #03a17b;\n    }\n\n    .bdp-error {\n        color: #ec4e4e;\n    }\n}\n\n::ng-deep {\n    .md-drppicker.inline {\n        width: max-content !important;\n        box-shadow: none !important;\n    }\n\n    .md-drppicker .btn {\n        background-color: #2d74ff !important;\n        border-radius: 5px !important;\n        margin-top: 12px;\n        font-family: \"Montserrat\" !important;\n    }\n\n    .md-drppicker .btn.btn-default {\n        background: white !important;\n        box-shadow: none;\n        float: right;\n        margin-right: 8px;\n        // margin-top: 14px;\n    }\n\n    .md-drppicker td.active {\n        background-color: #2d74ff !important;\n    }\n}\n\n//Kpi indicator tooltip\n::ng-deep {\n    .overview-box-1 .overview-content .overview-graph>span:hover .graph-tooltip {\n        left: -65px;\n    }\n}\n\n::ng-deep {\n\n    // user-control companies panel\n    .bdp-extracompanies-panel .p-overlaypanel-content {\n        max-height: 256px !important;\n        overflow-y: auto !important;\n    }\n}\n\n::ng-deep {\n\n    .bdp-table {\n        background-color: #fff;\n    }\n\n    .bdp-table-icon-header {\n        min-width: 100px !important;\n        text-align: center !important;\n    }\n\n    .bdp-table-column-width {\n        min-width: 300px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
